import styled from 'styled-components';
import _ from 'lodash';

export default function HaizeaResidualImpactProbElement(props) {
  const {
    state,
    type = '',
    color = 'success',
  } = props;

  if (_.isNull(state)) return <></>;

  return (
    <Container title="Riesgos penales">
      <Value className="text-center">
        <span className={`badge badge-${color}`} style={{ padding: '5px 5px' }}>
          {`${type}: ${state}`}
        </span>
      </Value>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  font-size: 11px;
  padding: 9px 0;
`;
const Value = styled.div`
  font-weight: bold;
  font-size: 13px;
`;
